module.exports = __webpack_public_path__ + "img/hr-storage-tank.8b876c4d.png";